export default __webpack_public_path__ + "static/media/cook1.01990e6f.jpeg";